import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import AttachmentsTable from './AttachmentsTable';

const styles = () => ({
  paper: {
    maxWidth: 1050,
    minWidth: 1050,
  },
});

const AttachmentsDialog = ({
  open,
  onClose,
  attachments,
  onAttachmentView,
  business,
  classes,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    onEnter={this.onDialogEnter}
    onExited={this.onDialogExited}
    maxWidth="md"
    classes={{
      paper: classes.paper,
    }}
  >
    <DialogTitle onCloseClick={onClose}>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Attachments
      </Typography>
    </DialogTitle>
    <DialogContent
      withScrollbars
      disableGutters
      fullHeight
    >
      <AttachmentsTable
        attachments={attachments}
        business={business}
        onAttachmentView={onAttachmentView}
      />
    </DialogContent>
  </Dialog>
);

AttachmentsDialog.propTypes = {
  attachments: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  onAttachmentView: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
  }).isRequired,
};

AttachmentsDialog.defaultProps = {
  open: false,
  onClose: () => {},
  business: {},
};

export default withStyles(styles)(AttachmentsDialog);



// WEBPACK FOOTER //
// ./src/components/reports/AttachmentsDialog/AttachmentsDialog.js